<script>
import { getExportFile } from '@/api/config/export-file'

export default {
  name: 'ExportFile',
  data() {
    return {
      loading: false,
      total: 0,
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      this.loading = true
      getExportFile(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    down(path) {
      window.open(process.env.VUE_APP_BASE_API + '/' + path)
    }
  }
}
</script>

<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>导出列表</span>
          <el-button style="margin-left: 5px;" type="primary" size="mini" icon="el-icon-refresh-left" :loading="loading" @click="getTables">刷新</el-button>
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="time"
            label="导出日期"
            align="center"
          />
          <el-table-column
            prop="title"
            label="文件名"
            align="center"
          />
          <el-table-column
            prop="title"
            label="状态"
            align="center"
          >
            <template scope="{row}">
              <span v-if="row.status == 0" style="#E6A23C">进行中</span>
              <span v-else style="#67C23A">完成</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template scope="{row}">
              <el-button :disabled="row.status==0" icon="el-icon-download" :loading="loading" type="success" size="mini" @click="down(row.path)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>
